import React from 'react';
import {CounterContainer} from 'components';

const CounterPage = () => (
    <div>
        <CounterContainer />
    </div>
);

export default CounterPage;


// WEBPACK FOOTER //
// ./src/components/5.environments/CounterPage/index.js